import { getAds, getNewsList } from "actions/requests";
import classNames from "classnames";
import Image from "next/image";
import Link from "next/link";
import cookie from "cookie";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import en from "rc-pagination/lib/locale/en_US";
import vi from "rc-pagination/lib/locale/vi_VN";
import React, { useEffect, useState } from "react";
import RegisterDocument from "../../component/News/RegisterDocument";
import newsLang from "../../i18n/news";
import ContainerFluid from "./../../component/ContainerFluid";
import Footer from "./../../component/Footer";
import Header from "./../../component/Header/Header";
import NewsCard from "./../../component/News/NewsCard";
import NewsSidebar from "./../../component/News/NewsSidebar";
import PopupComponent from "./../../component/Popup";
import StickyContact from "./../../component/StickyContact";
import styles from "./News.module.scss";

const News = ({
  locale,
  newsList,
  hotNews,
  pinNews,
  banner,
  popup,
  linkedin,
}) => {
  const [news, setNews] = useState([]);
  const [filter, setFilter] = useState({
    page: 1,
    perPage: 6,
    status: 1,
    lang_id: locale === "vi" ? 1 : 2,
  });

  useEffect(() => {
    setNews(newsList.data);
  }, [newsList]);

  useEffect(() => {
    setFilter({
      page: 1,
      perPage: 6,
      status: 1,
      lang_id: locale === "vi" ? 1 : 2,
    });
  }, [locale]);

  const handleChangePage = (current, pageSize) => {
    setFilter((prev) => ({ ...prev, page: current, perPage: pageSize }));
    getNewsList({ ...filter, page: current, perPage: pageSize }).then((res) =>
      setNews(res.data.data)
    );
  };

  return (
    <>
      <ContainerFluid>
        <Header />
        <PopupComponent locale={locale} name="popup_news">
          <Link href={popup?.data[0]?.data_info?.link || "#"}>
            <a>
              <Image
                src={
                  popup?.data[0]?.images?.image
                    ? process.env.NEXT_PUBLIC_MEDIA_FILE +
                      popup?.data[0].images.image
                    : "/static/service_benefit.png"
                }
                width={720}
                height={450}
                layout="responsive"
              />
            </a>
          </Link>
        </PopupComponent>
        <ContainerFluid>
          <div
            className={classNames(
              "py-4 text-white w-100 container-fluid",
              styles.topBanner
            )}
          >
            <p
              className={classNames(
                "text-center mb-3 font-weight-bold",
                styles.title
              )}
            >
              {newsLang.banner.title[locale]}
            </p>
            <p className={classNames("text-center mb-0", styles.subTitle)}>
              {newsLang.banner.sub_title[locale]}
            </p>
          </div>
          <div className={classNames("container py-4", styles.newsContent)}>
            <div className="row mb-5">
              <div className="col-lg-8">
                <div className="row">
                  {pinNews.data?.map((item, index) => (
                    <div key={item.id.toString()} className="col-lg-12 mb-3">
                      <NewsCard
                        className={classNames(
                          "px-3 pb-3 pt-2",
                          styles.newsCard
                        )}
                        classButton={styles.readMore}
                        id={item.id}
                        slug={item.slug?.substring(0, item.slug.length - 9)}
                        title={item.title}
                        desc={item.short_content}
                        created_at={item.created_at}
                        src={
                          item?.images?.image
                            ? process.env.NEXT_PUBLIC_MEDIA_FILE +
                              item.images.image
                            : "/static/news_thumb.png"
                        }
                        locale={locale}
                        objectFit="scale-down"
                      />
                    </div>
                  ))}
                  {news?.map((item) => (
                    <div
                      key={item.id.toString()}
                      className="col-12 col-md-6 my-3"
                    >
                      <NewsCard
                        className={classNames(
                          "px-3 pb-3 pt-2",
                          styles.newsCard
                        )}
                        classButton={styles.readMore}
                        id={item.id}
                        slug={item.slug?.substring(0, item.slug.length - 9)}
                        title={item.title}
                        desc={item.short_content}
                        created_at={item.created_at}
                        src={
                          item?.images?.image
                            ? process.env.NEXT_PUBLIC_MEDIA_FILE +
                              item.images.image
                            : "/static/news_thumb.png"
                        }
                        locale={locale}
                        objectFit="scale-down"
                      />
                    </div>
                  ))}
                  <div className="col-lg-12 mt-4 mb-5 mb-lg-0">
                    <Pagination
                      pageSize={filter.perPage}
                      total={newsList.total}
                      current={filter.page * 1}
                      onChange={handleChangePage}
                      locale={locale === "vi" ? vi : en}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-4">
                <NewsSidebar
                  bannerLink={banner?.data[0]?.data_info?.link}
                  bannerUrl={banner?.data[0]?.images?.image}
                  hotNews={hotNews}
                  locale={locale}
                  linkedin={linkedin}
                />
              </div>
            </div>
            <div className="row mb-5">
              <div className="d-none d-md-block col-lg-12">
                <RegisterDocument locale={locale} className="px-5" />
              </div>
              <div className="d-block d-md-none col-lg-12">
                <RegisterDocument locale={locale} vertical />
              </div>
            </div>
          </div>
        </ContainerFluid>
        <Footer />
        <StickyContact className={styles.stickyContact} />
      </ContainerFluid>
    </>
  );
};

export const getServerSideProps = async (params) => {
  const cookieValue = params.req?.headers.cookie || "";
  const showPopup = cookie.parse(cookieValue)?.popup_news;
  let popup;

  const typeImage = {
    banner: 1,
    popup: 2,
    linkedin: 3,
  };

  const { data } = await getNewsList({
    lang_id: params.locale === "vi" ? 1 : 2,
    status: 1,
    page: 1,
    perPage: 6,
  });

  const hotNews = await getNewsList({
    lang_id: params.locale === "vi" ? 1 : 2,
    status: 1,
    hot: 1,
  });

  const pinNews = await getNewsList({
    lang_id: params.locale === "vi" ? 1 : 2,
    status: 1,
    pin: 1,
  });

  const banner = await getAds({
    page: 1,
    perPage: 1,
    type: typeImage.banner,
    status: 1,
    lang_id: params.locale === "vi" ? 1 : 2,
  });

  const linkedin = await getAds({
    page: 1,
    perPage: 1,
    type: typeImage.linkedin,
    status: 1,
    lang_id: params.locale === "vi" ? 1 : 2,
  });

  if (showPopup === undefined) {
    popup = await getAds({
      page: 1,
      perPage: 1,
      type: typeImage.popup,
      status: 1,
      lang_id: params.locale === "vi" ? 1 : 2,
    });
  }

  return {
    props: {
      newsList: data,
      hotNews: hotNews?.data,
      pinNews: pinNews?.data,
      banner: banner?.data,
      linkedin: linkedin?.data,
      popup: popup?.data || null,
    },
  };
};

export default News;
